import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../../stores/authStore';

interface Props {
  module: string;
  children: React.ReactNode;
}

export default function ModuleRoute({ module, children }: Props) {
  const { hasModule } = useAuthStore();
  if (!hasModule(module)) return <Navigate to="/" replace />;
  return <>{children}</>;
}
